/**
 * Whether two JSON values say the same thing, ignoring object key order.
 *
 * The server stores flow JSON as Postgres jsonb, which reorders object keys, so the flow that
 * comes back is never byte-identical to the one sent even when nothing changed. Comparing by
 * JSON.stringify would call every round trip an edit.
 */
const canonical = (value) => {
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce((out, key) => {
      if (value[key] !== undefined) out[key] = canonical(value[key]);
      return out;
    }, {});
  }
  return value;
};

export const jsonEquals = (a, b) => JSON.stringify(canonical(a)) === JSON.stringify(canonical(b));
